import React, { Component, createRef } from "react";
import PlusIcon from "../icons/plusicon";
import WaitlistFaq from "../component/WaitlistFaq";
import Loader from "../component/loader";
import service from "../services";
import moment from "moment-timezone";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import isEqual from "lodash/isEqual";

let sub;

// Every field is optional; empty text means nothing extra is displayed to users
const CONTENT_OPTIONS = [
  { name: "waitlistJoinedMessage", label: "You are on the waitlist!" },
  { name: "waitlistJoinedCompanionMessage", label: "You and a companion are on the waitlist!" },
  { name: "companionWaitlistMessage", label: "Companion Waitlist Message" },
  { name: "emptyWaitlistMessage", label: "Empty Waitlist Message" },
  { name: "getWaitlistPassNoteMessage", label: "Join Waitlist Note" },
  { name: "waitlistPassSignupMessage", label: "Add Waitlist Payment Method Modal" },
  { name: "waitlistPassSignupNoteMessage", label: "Add Waitlist Payment Method Modal Note" },
  { name: "waitlistBillingUpdateMessage", label: "Billing (Credit Card Required) Modal" },
  { name: "waitlistPassJoinedSuccessMessage", label: "Waitlist Payment Method Added Modal" },
];
const FIELD_NAMES = CONTENT_OPTIONS.map((o) => o.name);

const TOOLBAR = {
  blockType: { inDropdown: true, options: ["Normal", "Blockquote"] },
  inline: { inDropdown: true, options: ["bold", "italic", "underline", "strikethrough"] },
  list: { inDropdown: true, options: ["unordered", "ordered"] },
  textAlign: { inDropdown: true },
  link: { inDropdown: true },
  history: { inDropdown: true },
  options: ["inline", "blockType", "list", "link", "textAlign"],
};

const toHtml = (editorState) => {
  if (!editorState || !editorState.getCurrentContent().hasText()) return "";
  return draftToHtml(convertToRaw(editorState.getCurrentContent())).trim();
};

const toEditor = (html) => {
  if (!html) return EditorState.createEmpty();
  const { contentBlocks, entityMap } = htmlToDraft(html);
  return EditorState.createWithContent(ContentState.createFromBlockArray(contentBlocks, entityMap));
};

export default class MyWaitlists extends Component {
  constructor(props) {
    super(props);
    const editors = {};
    FIELD_NAMES.forEach((name) => (editors[name] = EditorState.createEmpty()));
    this.state = {
      activetab: 0,
      selectedContent: FIELD_NAMES[0],
      loaderFlag: true,
      ...editors,
      initialData: null,
      ticketHomeId: "",
      isEdited: false,
      showErrors: false,
      updatedAt: null,
      updatedBy: "",
    };
    this.tabs = ["My Waitlists", "Waitlist FAQ"];
    this.apiserve = new service();
    this.faqRef = createRef();
  }

  getCurrentFormData = () => {
    const data = {};
    FIELD_NAMES.forEach((name) => (data[name] = toHtml(this.state[name])));
    return data;
  };

  componentDidMount = () => {
    sub = this.apiserve.getevent().subscribe((response) => {
      switch (response.event) {
        case "ticketCms|ticketHome|getList": {
          if (response.error) {
            this.setState({ loaderFlag: false });
            break;
          }
          const doc = (response.data && response.data.docs && response.data.docs[0]) || {};
          const waitListMessages = doc.waitListMessages || {};
          // The FAQ tab reloads the same list; keep unsaved edits
          if (this.state.isEdited) break;
          const editors = {};
          FIELD_NAMES.forEach((name) => (editors[name] = toEditor(waitListMessages[name])));
          this.setState(
            {
              ...editors,
              loaderFlag: false,
              ticketHomeId: doc._id || "",
              updatedAt: doc.updatedAt || null,
              updatedBy: doc.updatedBy ? `${doc.updatedBy.fname || ""} ${doc.updatedBy.lname || ""}`.trim() : "",
            },
            () => this.setState({ initialData: this.getCurrentFormData(), isEdited: false })
          );
          break;
        }
        case "waitList|updateWaitlistMessages":
          if (response.error) {
            this.setState({ loaderFlag: false });
            this.apiserve.error("We could not save your changes. Please check that every message is filled in and try again.");
          } else {
            this.apiserve.success("My Waitlists content updated successfully.");
            this.setState({ isEdited: false, showErrors: false }, this.getContent);
          }
          break;
        default:
          break;
      }
    });
    this.getContent();
  };

  componentWillUnmount = () => {
    if (sub) sub.unsubscribe();
  };

  getContent = () => {
    this.setState({ loaderFlag: true });
    this.apiserve.sendevent("ticketCms|ticketHome|getList", {});
  };

  onEditorChange = (name, editorState) => {
    this.setState({ [name]: editorState }, () => {
      if (this.state.initialData) {
        const isEdited = !isEqual(this.state.initialData, this.getCurrentFormData());
        if (isEdited !== this.state.isEdited) this.setState({ isEdited });
      }
    });
  };

  save = (e) => {
    e.preventDefault();
    // All messages are required: jump to the first empty one and say what to do
    const missing = CONTENT_OPTIONS.find((o) => !toHtml(this.state[o.name]));
    if (missing) {
      this.setState({ showErrors: true, selectedContent: missing.name });
      return;
    }
    this.setState({ loaderFlag: true });
    this.apiserve.sendevent("waitList|updateWaitlistMessages", { id: this.state.ticketHomeId, ...this.getCurrentFormData() });
  };

  cancel = () => this.setState({ isEdited: false, showErrors: false }, this.getContent);

  addQuestion = (e) => {
    e.stopPropagation();
    if (this.faqRef.current) this.faqRef.current.AddQuestion();
  };

  render() {
    const { activetab, selectedContent, showErrors, updatedAt, updatedBy, isEdited, loaderFlag } = this.state;
    const saveDisabled = loaderFlag || !isEdited;
    return (
      <React.Fragment>
        <div className="right_side_wrapper artistView_wrapper">
          <ul className="fpg_admin_tab disp_flex">
            {this.tabs.map((label, index) => (
              <li key={label} className={activetab === index ? "active" : ""} onClick={() => this.setState({ activetab: index })}>
                <p>
                  <div style={{ width: index === 1 && activetab === index ? "calc(100% - 58px)" : "100%" }}>{label}</div>
                  {index === 1 && activetab === index && (
                    <span className="add_icon d_flex" onClick={this.addQuestion}>
                      <PlusIcon />
                    </span>
                  )}
                </p>
              </li>
            ))}
          </ul>

          {activetab === 0 && (
            <>
              <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
                <p></p>
                <p className="update_date">
                  {updatedAt
                    ? `Last Update: ${moment.tz(updatedAt, "US/Mountain").format("hh:mm A")} MT - ${moment
                        .tz(updatedAt, "US/Mountain")
                        .format("MM/DD/YYYY")} Last Updated By: ${updatedBy}`
                    : ""}
                </p>
              </div>
              <div className="ticketing_content home_content home_page_content">
                <div className="ticketing_wrapper fpg_tabcontent">
                  <form>
                    <div className="sd_content_wrapper">
                      <div className="field_row horizontal_field">
                        <div className="field_row_inner">
                          <label>Content</label>
                          <div className="select_field relative">
                            <select value={selectedContent} onChange={(e) => this.setState({ selectedContent: e.target.value })}>
                              {CONTENT_OPTIONS.map((o) => (
                                <option key={o.name} value={o.name}>
                                  {o.label}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="field_row horizontal_field">
                        <div className="field_row_inner">
                          <label>{(CONTENT_OPTIONS.find((o) => o.name === selectedContent) || {}).label} Text *</label>
                          <div className="field_input editor_wrapper sd_num_margin">
                            <Editor
                              wrapperClassName="sd_text_editor"
                              editorState={this.state[selectedContent]}
                              onEditorStateChange={(es) => this.onEditorChange(selectedContent, es)}
                              toolbar={TOOLBAR}
                              editorStyle={{ height: "200px" }}
                            />
                            {showErrors && !toHtml(this.state[selectedContent]) && (
                              <span className="error">Please enter the {(CONTENT_OPTIONS.find((o) => o.name === selectedContent) || {}).label} text.</span>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="text_center field_row w_100 buttons_outer mb_0">
                      <button type="button" className="uppercase" onClick={this.cancel}>
                        CANCEL
                      </button>
                      <button type="button" disabled={saveDisabled} className={`uppercase ${saveDisabled ? "" : "active"}`} onClick={this.save}>
                        SAVE
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </>
          )}
          {activetab === 1 && <WaitlistFaq ref={this.faqRef} />}
        </div>
        {loaderFlag && activetab === 0 ? <Loader /> : ""}
      </React.Fragment>
    );
  }
}
